import axios from "axios";
import auth0Client from "@/utils/auth0Client";
import * as AppStorage from "@/utils/appStorage";
import config from "@/config/env.config.json";
import logger from "@/utils/logger";

const envConfig = config[process.env.NODE_ENV];
const consumerBaseUrl = envConfig.consumerApiBaseUrl;
const dataApiBaseUrl = envConfig.dataApiBaseUrl;

const shouldLogoutForAuthError = (error) => {
  const status = error.response && error.response.status;
  const url = error.config && error.config.url;
  const isAuthError = status === 401 || status === 403;

  return isAuthError && url && url.includes(consumerBaseUrl);
};

export const setupInterceptors = () => {
  // This is used to automatically add the accessToken to outgoing requests for the consumer or data apis
  axios.interceptors.request.use((config) => {
    logger.info("Setting token on request ", config.url);
    const accessToken = AppStorage.get("accessToken");

    if (!accessToken) {
      return config;
    }

    if (config.url.includes(consumerBaseUrl)) {
      config.headers["JWT"] = `Bearer ${accessToken}`;
    } else if (config.url.includes(dataApiBaseUrl)) {
      config.headers["Authorization"] = `Bearer ${accessToken}`;
    }

    return config;
  });

  axios.interceptors.response.use(
    (response) => {
      // Any status code that lie within the range of 2xx cause this function to trigger
      // Do something with response data
      return response;
    },
    (error) => {
      // Any status codes that falls outside the range of 2xx cause this function to trigger
      // Do something with response error
      if (shouldLogoutForAuthError(error)) {
        // User is not authed to use APIs, logout (which sends back to login page)
        auth0Client.logout();
      }

      return Promise.reject(error);
    }
  );
};
